export interface Upgrades {
  push: number;
  weight: number;
  speed: number;
  control: number;
}

export enum UpgradeTree {
  Push = 'push',
  Weight = 'weight',
  Speed = 'speed',
  Control = 'control',
}

export type UpgradePurchaseReason =
  | 'insufficient_orbs'
  | 'max_level'
  | 'player_eliminated'
  | 'invalid_level'
  | 'rate_limited';

export interface UpgradePurchaseRequest {
  requestId: string;
  stat: UpgradeTree;
  expectedCurrentLevel: number;
  clientTimestamp: number;
}

export interface UpgradePurchaseResult {
  requestId: string;
  success: boolean;
  stat: UpgradeTree;
  newLevel: number;
  remainingOrbs: number;
  nextCost: number | null;
  reason?: UpgradePurchaseReason;
}

export interface UpgradeDefinition {
  tree: UpgradeTree;
  level: number;
  cost: number;
  effect: string;
  multiplier: number;
}

export const UPGRADE_DEFINITIONS: Record<UpgradeTree, UpgradeDefinition[]> = {
  [UpgradeTree.Push]: [
    { tree: UpgradeTree.Push, level: 1, cost: 3, effect: '+20% de potencia de impacto', multiplier: 1.2 },
    { tree: UpgradeTree.Push, level: 2, cost: 5, effect: '+40% de potencia de impacto', multiplier: 1.4 },
    { tree: UpgradeTree.Push, level: 3, cost: 8, effect: '+60% de potencia de impacto', multiplier: 1.6 },
    { tree: UpgradeTree.Push, level: 4, cost: 12, effect: '+80% de potencia de impacto', multiplier: 1.8 },
  ],
  [UpgradeTree.Weight]: [
    { tree: UpgradeTree.Weight, level: 1, cost: 2, effect: '-15% de empuje recibido', multiplier: 0.85 },
    { tree: UpgradeTree.Weight, level: 2, cost: 4, effect: '-30% de empuje recibido', multiplier: 0.70 },
    { tree: UpgradeTree.Weight, level: 3, cost: 7, effect: '-45% de empuje recibido', multiplier: 0.55 },
    { tree: UpgradeTree.Weight, level: 4, cost: 10, effect: '-60% de empuje recibido', multiplier: 0.40 },
  ],
  [UpgradeTree.Speed]: [
    { tree: UpgradeTree.Speed, level: 1, cost: 2, effect: '+15% de velocidad', multiplier: 1.15 },
    { tree: UpgradeTree.Speed, level: 2, cost: 4, effect: '+30% de velocidad', multiplier: 1.30 },
    { tree: UpgradeTree.Speed, level: 3, cost: 7, effect: '+45% de velocidad', multiplier: 1.45 },
    { tree: UpgradeTree.Speed, level: 4, cost: 10, effect: '+60% de velocidad', multiplier: 1.60 },
  ],
  [UpgradeTree.Control]: [
    { tree: UpgradeTree.Control, level: 1, cost: 3, effect: '+12% de control y recuperación', multiplier: 1.12 },
    { tree: UpgradeTree.Control, level: 2, cost: 5, effect: '+24% de control y recuperación', multiplier: 1.24 },
    { tree: UpgradeTree.Control, level: 3, cost: 8, effect: '+36% de control y recuperación', multiplier: 1.36 },
    { tree: UpgradeTree.Control, level: 4, cost: 12, effect: '+48% de control y recuperación', multiplier: 1.48 },
  ],
};
